import React from 'react';
import { Navigate } from 'react-router-dom';
import { LogOut, RotateCcw, Shield } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { toast } from '../hooks/use-toast';
import { useData } from '../context/DataContext';
import ArchiveManager from '../components/admin/ArchiveManager';
import TipstersEditor from '../components/admin/TipstersEditor';
import TrustStatsEditor from '../components/admin/TrustStatsEditor';

export default function AdminPanel() {
  const { authed, logout, resetAll } = useData();
  if (!authed) return <Navigate to="/admin" replace />;

  const reset = async () => {
    if (!window.confirm('Reset ALL content (archives, tipsters, trust numbers) to the built-in defaults? This cannot be undone.')) return;
    await resetAll();
    toast({ title: 'Reset complete', description: 'All content reverted to defaults.' });
  };

  return (
    <>
      <Header />
      <section className="bg-mist min-h-[80vh] py-10" data-testid="admin-panel">
        <div className="max-w-6xl mx-auto px-5 md:px-8">
          <div className="flex flex-wrap items-center justify-between gap-4 mb-8">
            <div className="flex items-center gap-3">
              <div className="w-11 h-11 rounded-xl bg-navy text-white flex items-center justify-center"><Shield className="w-5 h-5" /></div>
              <div>
                <div className="eyebrow text-royal">Admin</div>
                <h1 className="font-display text-2xl md:text-3xl font-extrabold text-navy">Content manager</h1>
              </div>
            </div>
            <div className="flex gap-2">
              <Button variant="outline" onClick={reset} className="rounded-full border-line" data-testid="admin-reset"><RotateCcw className="w-4 h-4 mr-1.5" /> Reset defaults</Button>
              <Button variant="outline" onClick={logout} className="rounded-full border-line" data-testid="admin-logout"><LogOut className="w-4 h-4 mr-1.5" /> Sign out</Button>
            </div>
          </div>

          <Tabs defaultValue="archive">
            <TabsList className="bg-white border border-line rounded-full p-1 h-auto">
              <TabsTrigger value="archive" className="rounded-full px-5 py-2 data-[state=active]:bg-navy data-[state=active]:text-white" data-testid="admin-tab-archive">Archives</TabsTrigger>
              <TabsTrigger value="tipsters" className="rounded-full px-5 py-2 data-[state=active]:bg-navy data-[state=active]:text-white" data-testid="admin-tab-tipsters">Tipsters</TabsTrigger>
              <TabsTrigger value="stats" className="rounded-full px-5 py-2 data-[state=active]:bg-navy data-[state=active]:text-white" data-testid="admin-tab-stats">Trust numbers</TabsTrigger>
            </TabsList>
            <TabsContent value="archive" className="mt-6"><ArchiveManager /></TabsContent>
            <TabsContent value="tipsters" className="mt-6"><TipstersEditor /></TabsContent>
            <TabsContent value="stats" className="mt-6"><TrustStatsEditor /></TabsContent>
          </Tabs>
        </div>
      </section>
      <Footer />
    </>
  );
}
